export const colors = {blue:'#0B5CD7'};
